import * as React from "react";

import "./line.scss";

import {formatMoney}    from "@Common/ui-components/language/format-money";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";

export const Line = ({label, selected=undefined, avaiAmount, appliedAmount, apiError=undefined, storeCreditDesc = undefined}) => (
    <div className="line-5w1">
        <div className="checkbox">
            {selected && (
                <SliderCheckbox {...{...selected, xdQaName: label+(storeCreditDesc? " "+storeCreditDesc:"")}}/>
            )}
        </div>
        <div className="label" onClick={selected && (() => selected.onChange(!selected.value))} xd-qa-type="label" xd-qa-name={label+(storeCreditDesc? " "+storeCreditDesc:"")}>
            {label}
        </div>
        <div className="value">
            <div className="avai" xd-qa-type="label" xd-qa-name={label+(storeCreditDesc? " "+storeCreditDesc:"") +" Value"}>
                {formatMoney(avaiAmount)}
            </div>

            {appliedAmount && (
                <div className="applied" xd-qa-type="label" xd-qa-name={label+(storeCreditDesc? " "+storeCreditDesc:"")  + " Applied"}>
                    {"(" + formatMoney(appliedAmount) + " applied)"}
                </div>
            )}
            {apiError && (
                <div className="error" xd-qa-type="label" xd-qa-name={label+(storeCreditDesc? " "+storeCreditDesc:"")  + " Error"}>
                    {apiError}
                </div>
            )}
            {storeCreditDesc && InformationBadge({
                height: 38,
                getTooltip: () => storeCreditDesc,
                xdQaName : label+(storeCreditDesc? " "+storeCreditDesc:"")
            })}
        </div>
    </div>
);
